import { useDallasKeys } from '@/utils/config';
import { Stack } from '@mui/material';
import { OptionsTable } from './OptionsTable';

export function RfidCardOptions() {
  return (
    <Stack direction="row" spacing={1} sx={{ p: 1 }}>
      <title>
        {useDallasKeys ? 'IR3 | Dallas Key Options' : 'IR3 | RFID Card Options'}
      </title>
      <OptionsTable name="rfidCardType" title="Types" />
    </Stack>
  );
}
